export default class Package {
    id: string
    label: string

    constructor (data: any) {
        this.id = data.id
        this.label = data.label
    }
}


// WEBPACK FOOTER //
// ./src/models/Package.ts